import styled from 'styled-components';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { COLORS } from '~/src/styles/tokens/colors';

export const Empty = styled.span`
    ${FONTS.compact.regular.size17};
    color: ${COLORS.textNegative};
`;